<template>
  <div>
    <titleBox name="旷真刑事辩护" imgUrl="../../assets/zhichanBg.jpg"></titleBox>
    <!-- 服务成果 -->
    <div
      class="itemBox"
      style="background-image: url(https://kz-images.oss-cn-shenzhen.aliyuncs.com/kzweb/Mobile/numberImg/marriage-01-BG.png);"
      id="chenggou"
    >
      <h2 class="titleBox">
        <img
          src="https://kz-images.oss-cn-shenzhen.aliyuncs.com/kzweb/Mobile/numberImg/01.png"
          class="numberImg"
          alt=""
        />
        服务成果<span class="redColor"></span>
        <i class="redIcon"></i>
      </h2>
      <div class="fwcg-content">
        <div v-for="item in fwcgList" class="fwcg-item mb-40">
          <span class="num redColor"
            ><countTo
              :startVal="0"
              separator=""
              :endVal="item.number"
              :duration="2000"
              style="margin-right: -0.2rem"
            ></countTo
            >{{item.unit}}</span
          >
          <p class="content" v-if="item.describe1">{{item.describe1}}</p>
          <p class="content" v-if="item.describe2">{{item.describe2}}</p>
          <p class="content" v-if="item.describe3">{{item.describe3}}</p>
        </div>
      </div>
    </div>
    <div
      class="itemBox"
      id="chanpin"
    >
      <h2 class="titleBox">
        <img
          src="https://kz-images.oss-cn-shenzhen.aliyuncs.com/kzweb/Mobile/numberImg/02.png"
          class="numberImg"
          alt=""
        />
        服务产品<span class="redColor"></span>
        <i class="redIcon"></i>
      </h2>
      <div class="fwcp-content">
        <div class="left">
          <img
            src="https://kz-images.oss-cn-shenzhen.aliyuncs.com/kzweb/pc/criminal/criminal-02-01.png"
            alt=""
          />
        </div>
        <div class="right">
          <div v-for="fwcpItem in fwcpList" class="fwcp-item" :style="`margin-top: ${fwcpItem.marginTop}rem`">
            <p class="content" v-if="fwcpItem.title">{{fwcpItem.title}}</p>
            <template v-if="fwcpItem.child">
              <div v-for="childItem in fwcpItem.child" class="fwcpChild-item">
                <div class="dot">•</div>
                <div class="fwcpChild-item-content">{{childItem}}</div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div
      class="itemBox"
      id="liucheng"
    >
      <h2 class="titleBox">
        <img
          src="https://kz-images.oss-cn-shenzhen.aliyuncs.com/kzweb/Mobile/numberImg/03.png"
          class="numberImg"
          alt=""
        />
        服务流程<span class="redColor"></span>
        <i class="redIcon"></i>
      </h2>
      <div class="fwlc-content">
        <div
          v-for="(activity, index) in fwlcList"
          :key="index"
          class="fwlc-item"
        >
          <div class="timeline-left">
            <img
              src="https://kz-images.oss-cn-shenzhen.aliyuncs.com/kzweb/pc/criminal/criminal-03-01.png"
              alt=""
            />
            <div class="timeline-left-id">{{activity.id}}</div>
          </div>
          <div class="timeline-center">
            <div class="timeline-dashed"></div>
            <img
              :src="activity.icon"
              style="width: 0.4rem; height: 0.3rem"
              class="img-style"
            />
          </div>
          <div class="timeline-right">
            <div class="timeline-right-title">{{ activity.title }}</div>
            <div class="timeline-right-text" v-if="activity.content">
              {{ activity.content }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import titleBox from "../../components/titleBox/index";
import countTo from "vue-count-to";
export default {
  components: { titleBox, countTo },
  data() {
    return {
      fwcgList: [
        {
          number: 5,
          unit: "万+",
          describe1: "累计提供刑事",
          describe2: "法律服务次数",
          describe3: "5万+",
        },
        {
          number: 3000,
          unit: "+",
          describe1: "代理",
          describe2: "刑事案件",
          describe3: "3000+",
        },
        {
          number: 31,
          unit: "亿",
          describe1: "代理刑事案件",
          describe2: "单案最大",
          describe3: "涉案标的31个亿",
        },
        {
          number: 80.4,
          unit: "%",
          describe1: "取保候审率",
          describe2: "80.4%",
        },
        {
          number: 62,
          unit: "%",
          describe1: "争取不起诉决定",
          describe2: "62%",
        },
        {
          number: 76.8,
          unit: "%",
          describe1: "缓刑率",
          describe2: "76.8%",
        },
        {
          number: 14.2,
          unit: "%",
          describe1: "全案改判",
          describe2: "14.2%",
        }
      ],
      fwcpList: [
        {
          title: "01 刑事危机应对",
          child: [
            "企业刑事风险审查、评估与整改",
            "个人刑事风险的日常咨询与专项咨询"
          ],
          marginTop: 0.02,
        },
        {
          title: "02 举报与控告",
          child: [
            "企业内部调查、举报与控告",
            "被害人的控告与代理、追赃挽损"
          ],
          marginTop: 0.7,
        },
        {
          title: "03 调解、和解、谅解",
          child: [
            "追赃挽损谈判",
            "赔偿谅解谈判",
            "风险化解谈判"
          ],
          marginTop: -0.38,
        },
        {
          title: "04 刑事辩护",
          child: [
            "新型经济犯罪类型研究与辩护",
            "职务犯罪的研究与辩护",
            "涉税犯罪的研究与辩护",
            "知识产权类犯罪的研究与辩护",
            "海关缉私类犯罪研究与辩护",
            "金融证券类犯罪研究与辩护",
            "传统、常见犯罪类型辩护"
          ],
          marginTop: 0.23,
        },
        {
          title: "05 刑事申诉与死刑复核",
          child: [
            "法、检申诉申请",
            "立案听证会",
            "再审后辩护",
            "代理国家赔偿",
            "死刑复核程序的辩护"
          ],
          marginTop: -2.2,
        },
        {
          title: "06 快速取保候审"
        }
      ],
      fwlcList: [
        {
          id: "01",
          title: '全面了解案情',
          content: '审查委托代理手续、亲属关系证明等是否齐备；了解涉嫌罪名和案情；拟定办案计划书，初步形成辩护思路，报刑事专家、部长审批；',
          icon: "https://kz-images.oss-cn-shenzhen.aliyuncs.com/kzweb/pc/criminal/criminal-03-02.png",
          color: '#fff'
        }, {
          id: "02",
          title: '提供综合解决方案、形成办案计划书',
          content: '会见嫌疑人，形成《会见笔录》；收集整理有利的证据，补充完善办案计划；',
          icon: "https://kz-images.oss-cn-shenzhen.aliyuncs.com/kzweb/pc/criminal/criminal-03-02.png",
          color: '#fff'
        }, {
          id: "03",
          title: '向委托人反馈办案进展',
          content: '分析案件利弊与流程走势；',
          icon: "https://kz-images.oss-cn-shenzhen.aliyuncs.com/kzweb/pc/criminal/criminal-03-02.png",
          color: '#fff'
        }, {
          id: "04",
          title: '侦查阶段与主办人员高效沟通',
          content: '向办案机关递交《证据线索目录》,《取保候审申请书》或《不批准逮捕法律意见书》;向管辖检察院递交《羁押必要性审查申请书》;',
          icon: "https://kz-images.oss-cn-shenzhen.aliyuncs.com/kzweb/pc/criminal/criminal-03-02.png",
          color: '#fff'
        },{
          id: "05",
          title: '与被害人、受害方充分沟通',
          content: '争取被害人、受害方谅解、和解等；',
          icon: "https://kz-images.oss-cn-shenzhen.aliyuncs.com/kzweb/pc/criminal/criminal-03-02.png",
          color: '#fff'
        }, {
          id: "06",
          title: '审查起诉阶段和主办检察官多角度沟通',
          content: '形成《辩护词》初稿，报刑事专家、部长审批；与检察官沟通定罪量刑建议；',
          icon: "https://kz-images.oss-cn-shenzhen.aliyuncs.com/kzweb/pc/criminal/criminal-03-02.png",
          color: '#fff'
        }, {
          id: "07",
          title: '审判阶段与主审法官全方位沟通、庭审辩护',
          content: '申请庭前指正或非法证据排除；庭前刑事法庭模拟，控辩对抗演练；对定罪量刑，上诉可行性利弊分析；',
          icon: "https://kz-images.oss-cn-shenzhen.aliyuncs.com/kzweb/pc/criminal/criminal-03-02.png",
          color: '#fff'
        }, {
          id: "08",
          title: '二审或者再审、申请抗诉',
          content: '一审裁判结果与是否提起二审利弊分析；',
          icon: "https://kz-images.oss-cn-shenzhen.aliyuncs.com/kzweb/pc/criminal/criminal-03-02.png",
          color: '#fff'
        }, {
          id: "09",
          title: '全流程系统管控，保障案件处理质量',
          content: '关键举措汇报与定期汇报相结合，保障委托人对案件进度的知情权和信息同步及时性。',
          icon: "https://kz-images.oss-cn-shenzhen.aliyuncs.com/kzweb/pc/criminal/criminal-03-02.png",
          color: '#fff'
        }
      ]
    };
  },
};
</script>

<style lang="scss" scoped>
.redColor {
  color: #ab0000;
}
.itemBox {
  // width: 95%;
  margin: 0rem auto;
  padding: 0 0 0.5rem 0;
  background-color: #fff;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  .titleBox {
    width: 95%;
    margin: auto;
    padding-top: 0.5rem;
    margin-bottom: 0.2rem;
    position: relative;
    height: 1rem;
    line-height: 1rem;
    font-size: 0.5rem;

    .numberImg {
      position: relative;
      top: 0.05rem;
      width: 0.5rem;
      height: 0.5rem;
    }
  }
  .mt-2 {
    margin-top: 0.2rem;
  }
  .fwcp-content {
    display: flex;
    width: 95%;
    margin: auto;
    .left {
      margin-right: 0.2rem;
      img {
        width: 2rem;
      }
    }
    .right {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      .fwcp-item {
        width: 49%;
        .content {
          font-weight: bold;
          font-size: 0.32rem;
          background: #C8050F;
          color: #fff;
          width: 100%;
          padding: 0.1rem 0.04rem;
          border-radius: 0px 0.2rem 0px 0px;
          margin-bottom: 0.08rem;
        }
        .fwcpChild-item {
          padding: 0.06rem;
          display: flex;
          font-size: 0.24rem;
          color: #4C4C4C;
          .dot {
            color: #C8050F; /* 圆点颜色 */
            font-size: 0.2rem; /* 圆点大小 */
            margin-right: 0.1rem; /* 圆点和文字之间的间距 */
          }
          .fwcpChild-item-content {
            line-height: 0.32rem;
          }
        }
      }
    }
  }
  .fwcg-content {
    display: flex;
    margin: 0 auto 0.3rem;
    flex-wrap: wrap;
    padding: 0 0.2rem;
    justify-content: center;
    .fwcg-item {
      width: 20%;
      height: 2.2rem;
      background-color: #fff;
      text-align: center;
      margin-right: 0.5rem;
      padding-top: 0.2rem;
      .content {
        font-size: 0.25rem;
        color: #4C4C4C;
        line-height: 0.2rem;
      }
      img {
        height: 0.7rem;
        margin: 0.3rem 0;
      }
    }
    .fwcg-item:last-child,  .fwcg-item:nth-child(4){
      margin-right: 0;
    }
    .fwcg-item:nth-child(5),  .fwcg-item:nth-child(6), .fwcg-item:nth-child(7){
      margin-top: 0.5rem;
    }
  }
  .num {
    position: relative;
    font-family: DINAlternate-Bold, DINAlternate;
    font-size: 0.5rem;
    font-weight: 700;
  }
  .fwlc-content {
    width: 95%;
    margin: auto;
    .fwlc-item {
      display: flex;
      flex-direction: row;
      .timeline-center {
        position: relative;
        width: 0.5rem;
        display: flex;
        margin-top: 0.1rem;
        .timeline-dashed {
          width: 0.2rem;
          border-left: 0.07rem dashed #ccc;
          height: 100%;
        }
        .img-style {
          position: relative;
          display: flex;
          justify-content: center;
          align-items: center;
          left: -0.32rem;
        }
      }
      .timeline-left {
        width: 1.3rem;
        img {
          width: 0.8rem;
        }
        .timeline-left-id {
          width: 0.5rem;
          position: relative;
          top: -0.65rem;
          left: 0.15rem;
          font-size: 0.42rem;
          color: #fff;
          font-weight: bold;
        }
      }
      .timeline-right {
        width: 100%;
        .timeline-right-title {
          color: #AB0000;
          font-size: 0.4rem;
          font-weight: bold;
        }
        .timeline-right-text {
          color: #4C4C4C;
          font-size: 0.3rem;
          padding-bottom: 0.5rem;
        }
      }
    }
  }
  .bigBox {
    width: 90%;
    margin: 0.5rem auto;
    padding-left: 0.4rem;
    box-sizing: border-box;

    .header {
      position: relative;
      width: 100%;
      height: 5rem;
      // background-color: #f7f4f5;
      background-size: 100% 100%;
      background-repeat: no-repeat;
      text-align: center;
      background-image: url(https://kz-images.oss-cn-shenzhen.aliyuncs.com/kzweb/Mobile/abuout/itemBG.png);
      .isHot {
        position: absolute;
        left: 0;
        top: 0;
        background-color: #fa6e23;
        padding: 0.05rem 0.3rem;
        font-family: PingFangSC-Regular, PingFang SC;
        border-radius: 0px 0px 6px 0px;
        color: #ffffff;
      }
    }

    .title {
      margin: 0.2rem 0;
      color: #707070;
      font-size: 0.35rem;
      font-weight: 700;
    }

    .msg {
      font-size: 0.3rem;
      color: #666666;
      margin-bottom: 0.1rem;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    .watchMsg {
      color: #999;
      font-size: 0.3rem;
      .redIcon {
        position: relative;
        display: inline-block;
        top: -0.05rem;
        width: 8px;
        height: 7px;
        background-size: 100% 100%;
        background-image: url(http://kz-images.oss-cn-shenzhen.aliyuncs.com/kzweb/Mobile/redIcon.png);
      }
    }
  }
}

.redIcon {
  position: relative;
  display: inline-block;
  top: -0.25rem;
  width: 10px;
  height: 7px;
  background-size: 100% 100%;
  background-image: url(http://kz-images.oss-cn-shenzhen.aliyuncs.com/kzweb/Mobile/redIcon.png);
}
.loadMore {
  padding: 0.3rem 0;
  text-align: center;
}
</style>
